export const LOAD_RESTAURANT = 'LOAD_RESTAURANT'
export const SAVE_RESTAURANT = 'SAVE_RESTAURANT'


